import { IS_NOT_EMPTY } from './../../utils/stringUtils';

export const FULL_NAME = (firstName: string, lastName: string): string => {
	let fullName = '';
	if (IS_NOT_EMPTY(firstName)) {
		fullName = firstName;
	}
	if (IS_NOT_EMPTY(lastName)) {
		if (fullName.length > 0) {
			fullName += ' ';
		}
		fullName += lastName;
	}
	return fullName;
};
